module.exports = __webpack_public_path__ + "img/help_mater.6d0eab75.svg";